<template>
  <form
    @submit.prevent="emitFilter"
    class="release-filter inner-page-header width-all flex align-center space-between gap20 wrap"
  >
    <!-- Left: filters row -->
    <div class="release-filter-main flex align-center justify-start gap20">
      <!-- Funnel / clear -->
      <button type="button" class="filter-icon-btn" @click="setSortKey('')">
        <div v-html="svgs.icons.sort" class="svg-parrent sort-svg"></div>
      </button>

      <!-- Years dropdown -->
      <FormInput
        class="years-select"
        @change="setDateRange"
        type="select"
        placeholder="releaseLocales.allYears"
        :items="yearsOpts"
        v-model="dateSelectVal"
      />

      <!-- Thin separator -->
      <span class="filter-separator"></span>

      <!-- Date tab -->
      <button
        type="button"
        class="filter-tab"
        :class="{ active: filterBy.simpleSort === '_createdAt' }"
        @click="setSortKey('_createdAt')"
      >
        {{ $t('date') }}
      </button>

      <!-- Thin separator -->
      <span class="filter-separator"></span>

      <!-- A‑Z tab -->
      <button
        type="button"
        class="filter-tab"
        :class="{ active: filterBy.simpleSort === 'releaseData.title' }"
        @click="setSortKey('releaseData.title')"
      >
        {{ $t('A-Z') }}
      </button>
    </div>

    <!-- Right: page title -->
    <h2 v-if="pageTitle" class="release-page-title">
      {{ pageTitle }}
    </h2>
  </form>
</template>

<script>
import FormInput from '@/apps/common/modules/common/cmps/FormInput.vue';
import evManager from '@/apps/common/modules/common/services/event-emmiter.service.js';
import ToggleBtns from '../../../../common/modules/common/cmps/ToggleBtns.vue';
import { organizationService } from '../../organization/services/organization.service';
import ToggleModalOnlyForSmallScreen from '../../../../common/modules/common/cmps/ToggleModalOnlyForSmallScreen.vue';

import  { getSvgs as getGlobalSvgs } from '@/assets/images/svgs.js';
import  { getSvgs } from '@/apps/megaphonApp/assets/images/svgs.js';
export default {
  name: 'ReleaseFilter',
  props: {
    initFilter: {
      type: Object,
      required: true
    },
    selectedReleaseIds: {
      type: Array,
      default: () => []
    },
    inludeSearchInput: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      filterBy: null,
      // filterTypes: { // licenseType
      //   all: undefined,
      //   'release.purchase': '1',
      //   'release.original': '2',
      // },
      // didInit: false
      folderVal: '',
      dateSelectVal: '',
    }
  },
  computed: {
    isScreenWide() {
      return this.$store.getters.isScreenWide;
    },

    org() {
      return this.$store.getters['organization/selectedItem'];
    },
    
    loggedUser() {
      return this.$store.getters['auth/loggedUser'];
    },

    yearsOpts() {
      // return [2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, {value: undefined, label: 'clear'}].reverse();
      return [
        {value: undefined, label: 'releaseLocales.allYears'},
        ...(() => {
          const nowYear = new Date().getFullYear();
          const years = [];
          for (let year = nowYear; year >= 2017; year--) years.push(year);
          return years;
        })()
      ]
    },

    foldersOpts() {
      function parseFolders(folderItem = {name: '', children: []}, parsedFolders = [/* {label: 'release.outOfFolders', value: {folderPath: null, folder: null}} */], parentPath = '') {
        if (Array.isArray(folderItem)) {
          folderItem.forEach(c => parseFolders(c, parsedFolders, parentPath));
        } else {
          if (!folderItem?.name) return parsedFolders;
          const relPath = [parentPath, folderItem.name].filter(Boolean).join('/');
          parsedFolders.push({label: relPath, value: {folderPath: relPath, folder: folderItem}});
          folderItem.children.forEach(c => {
            parseFolders(c, parsedFolders, relPath);
          });
        }
        return parsedFolders;
      }
      return parseFolders(this.org?.folders) || []
    },

    
    searchImg() {
      return getGlobalSvgs('var(--clr-0)').search;
    },
    svgs() {
      return getSvgs('var(--clr-0)');
    },
    pageTitle() {
      if (!this.org) return '';
      const page = this.$route.query.page;
      if (page == 0) {
        return this.$t ? this.$t('releaseLocales.releases') : '';
      }
      const route = this.org.routes?.find(c => c.name === page);
      if (route?.name) return route.name;
      if (this.$t) return this.$t('releaseLocales.releases');
      return '';
    }
  },
  methods: {
    isRoleInOrg(role) {
      return organizationService.isUserRoleInOrg(this.org?._id, role, this.loggedUser);
    },
    emitFilter() {
      this.$emit('filtered', this.filterBy);
      this.didInit = true;
    },

    setFilterType(type) {
      this.filterBy.filter.params.type = type || undefined;
      this.emitFilter();
    },
    setSortKey(key) {
      // this.filterBy.sort = key ? { [key]: 1 } : {};
      this.filterBy.simpleSort = key;
      // for (let otherKey in this.filterBy.sort) this.filterBy.sort[otherKey] = 0;
      // if (key) this.filterBy.sort[key] = 1;
      this.emitFilter();
    },

    setDateRange(val) {
      if (!val) {
        this.filterBy.filter.datesRange = undefined;
        this.dateSelectVal = '';
      }
      else {
        const yearTime = new Date(val, 0, 1, 0, 0, 0, 0);
        const dateRange = {
          from: yearTime.getTime(),
          to: yearTime.setFullYear(val+1)
        }
        this.filterBy.filter.datesRange = dateRange;
      }
      this.emitFilter();
    },

    addToFolder(val) {
      evManager.emit('folder-updated', this.org._id, val.folderPath, val.folder);
      this.folderVal = '';
    },
    onSearch(searchTerm) {
      this.filterBy.filter.search = searchTerm;
      this.emitFilter();
    },
    initFilterItem() {
      this.filterBy = JSON.parse(JSON.stringify(this.initFilter));
    }
  },
  created() {
    this.initFilterItem();
    this.filterBy.simpleSort = '_createdAt';
    evManager.on('searchReleases', this.onSearch);
    // this.filterBy.filter.params.type = this.filterBy.filter.params.type || '';
  },
  destroyed() {
    evManager.off('searchReleases', this.onSearch);
  },
  watch: {
  //   filterBy: {
  //     deep: true,
  //     handler() {
  //       this.emitFilter();
  //     } 
  //   }
    initFilter: {
      deep: true,
      handler() {
        this.initFilterItem();
      }
    }
  },
  components: { FormInput, ToggleBtns, ToggleModalOnlyForSmallScreen }
}
</script>

<style lang="scss">
@import '@/assets/styles/global/index';
.dark-theme.megaphon-app {
  .release-filter, .toggle-btns button {
    color: #cdcdcd;
  }

}
.megaphon-app {
  .release-filter {
    margin-bottom: em(20px);
    flex-direction: row;
    direction: ltr; // force LTR so first child is left, second is right
    // .toggle-btns button {
    //   color: var(--clr-0);
    // }
    .filter-items {
      >* {
        &:not(:last-child) {
          @media (min-width: $small-screen-break) {
            border-inline-end: 1px solid var(--clr-0);
            padding-inline-end: em(12.5px);
          }
        }
      }
    }
    .release-page-title {
      font-size: em(22px);
      font-weight: 600;
      color: var(--clr-0);
      text-align: end;
    }


    .filter-icon-btn {
      background: none;
      border: none;
      padding: 0;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .form-input-select {
      min-width: unset;
      .input {
        .select {
          .head {
            background-color: unset !important;
          }
        }
      }
      .actual-input {
        border: 0;
      }
      .head {
        padding: 0;
      }
      .selected-preview {
        padding-inline-end: 0;
      }
    }
    

    .sort-svg {
      width: em(15px);
      height: em(15px);
    }

    .toggle-btns {
      background: unset;
      box-shadow: unset;
      button{
        border-inline-end: 0 !important;
        background-color: unset !important;
      }
    }

    .release-filter-main {
      direction: rtl;
    }

    .filter-tab {
      background: none;
      border: none;
      padding: 0 em(6px);
      font-size: em(15px);
      color: #A0A0A0;
      cursor: pointer;
      border-bottom: em(2px) solid transparent;
    }

    .filter-tab.active {
      font-weight: 600;
      color: var(--clr-0);
      border-bottom-color: var(--clr-4);
    }

    .filter-separator {
      display: inline-block;
      height: em(18px);
      border-inline-start: 1px solid #E7E7E7;
      margin-inline: em(8px);
    }

    select {
      width: em(100px);
    }
  
    .search {
      .filter-icon-img {
        width: em(15px);
        height: em(15px);
      }
      overflow: unset;
      border-bottom: em(1px) solid $light-gray;
      input {
        border: 0;
        border: unset;
        
  // border-bottom: em(1px) solid gray;
  
        // border-radius: 0;
      }
    }
  }

  // On mobile, center the inner header / filter bar instead of spacing between
  @media (max-width: $small-screen-break) {
    .release-filter.inner-page-header {
      justify-content: center !important;
      text-align: center;
    }
  }
}
</style>